import type { MarketVariants } from '@/lib/i18n'

export type Slide11Copy = {
  eyebrow: string
  title: string
  body: string
  /** Currency glyph + sign that precedes the animated number on the tip-of-
   *  iceberg debit ("-$", "-£", "-QAR ", etc.). */
  tipPrefix: string
  /** Text after the animated number. Empty for symbol-first currencies; Arabic
   *  puts the riyal after the figure (" ر.ق"). */
  tipSuffix: string
  /** Amount the tip-of-iceberg counter animates up to. Integer, the count-up
   *  renders cleanest without minor units. */
  tipAmount: number
  /** Alt text for the iceberg illustration. */
  icebergAlt: string
  card1Title: string
  card1Body: string
  card2Title: string
  card2Body: string
  card3Title: string
  card3Body: string
  card4Title: string
  card4Body: string
}

export const copy: MarketVariants<Slide11Copy> = {
  US: {
    eyebrow: 'The emotional aftermath',
    title: 'The hidden emotional toll',
    body: 'For many victims, financial loss is just the tip of the iceberg.',
    tipPrefix: '-$',
    tipSuffix: '',
    tipAmount: 12480,
    icebergAlt: 'Hidden emotional toll iceberg',
    card1Title: 'Loss of confidence',
    card1Body:
      'Victims may start to doubt their judgment and hesitate over everyday decisions.',
    card2Title: 'Fear and anxiety',
    card2Body:
      'Calls, messages, and emails can begin to feel threatening, even when nothing is wrong.',
    card3Title: 'Embarrassment',
    card3Body:
      'Self-blame often prevents victims from speaking up or seeking help.',
    card4Title: 'Social withdrawal',
    card4Body:
      'Some victims pull back to protect themselves from being hurt again.',
  },
  GB: {
    tipPrefix: '-£',
    // "judgment -> judgement" auto-handled by toMarketSpelling dictionary;
    // no override needed.
  },
  // CA / AU inherit US copy. judgement vs. judgment and defence vs. defense
  // spelling differences are auto-resolved by the spelling dictionary.
  QA: {
    // $12,480 at the doc's rough rate lands near QAR 45,000.
    tipPrefix: '-QAR ',
    tipAmount: 45000,
  },
  ar: {
    eyebrow: 'الأثر العاطفي',
    title: 'الثمن العاطفي الخفي',
    body: 'بالنسبة لكثير من الضحايا، الخسارة المالية ليست سوى قمة جبل الجليد.',
    tipPrefix: '-',
    tipSuffix: ' ر.ق',
    tipAmount: 45000,
    icebergAlt: 'جبل جليد يمثّل الثمن العاطفي الخفي',
    card1Title: 'فقدان الثقة',
    card1Body: 'قد يبدأ الضحايا بالشك في حكمهم على الأمور والتردد في القرارات اليومية.',
    card2Title: 'الخوف والقلق',
    card2Body:
      'قد تبدو المكالمات والرسائل والبريد الإلكتروني مصدر تهديد، حتى عندما لا يكون هناك أي خطأ.',
    card3Title: 'الإحراج',
    card3Body: 'غالباً ما يمنع لوم الذات الضحايا من التحدث أو طلب المساعدة.',
    card4Title: 'الانعزال الاجتماعي',
    card4Body: 'ينسحب بعض الضحايا لحماية أنفسهم من التعرّض للأذى مرة أخرى.',
  },
}
